var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoFileTemplateExport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 40,
    viewBox: "0 0 30 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 0H18.2322C18.8953 0 19.5312 0.263392 20 0.732233L29.2678 10C29.7366 10.4688 30 11.1047 30 11.7678V35C30 37.7614 27.7614 40 25 40H5C2.23858 40 0 37.7614 0 35V5C0 2.23858 2.23858 0 5 0ZM18.75 3.75V8.75C18.75 10.1307 19.8693 11.25 21.25 11.25H26.25L18.75 3.75Z",
    fill: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoFileTemplateExport);
export default __webpack_public_path__ + "static/media/ico-file-template-export.b6509b6e2d17b9ef52ae72a7f5021e53.svg";
export { ForwardRef as ReactComponent };